import React, { useContext, useEffect, useState } from 'react';
import "./style.scss"
import { Link } from "react-router-dom";
import Icon from 'react-icons-kit'
import { eye } from 'react-icons-kit/feather'
// icons 
import aboutIcon from "../../../assets/static/single-profile/Icon awesome-info-circle.svg"
import contactIcon from "../../../assets/static/single-profile/Icon feather-phone-call.svg"
import phoneIcon from "../../../assets/static/single-profile/Icon material-call.svg"
import emailIcon from "../../../assets/static/single-profile/Icon ionic-ios-mail.svg"
import lifeStyleIcon from "../../../assets/static/single-profile/Group 3066.svg"
import backgroundIcon from "../../../assets/static/single-profile/Group 3067.svg"
import familyIcon from "../../../assets/static/single-profile/Group 3070.svg"
import educationIcon from "../../../assets/static/single-profile/Group 3089.svg"

import { UserContext } from '../../../utils/context/userContext';
import ContactInfo from '../Modal/ContactInfo';
import Requests from "../../../utils/Requests/Index"
import { toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

const orDash = value => (value === null || value === undefined || value === '' ? "---" : value)

const DetailItem = ({ label, value, full }) => (
    <div className={`detail_item${full ? " full" : ""}`}>
        <span className="detail_label">{label}</span>
        <span className="detail_value">{orDash(value)}</span>
    </div>
)

const InfoBox = ({ icon, title, children }) => (
    <section className="info_box">
        <h5 className="details_title">
            <img src={icon} alt="icon" /> {title}
        </h5>
        {children}
    </section>
)

const Index = ({ data }) => {
    const [contactModel, setContactModel] = useState(false);
    const [contactShow, setContactShow] = useState(false);
    const { user, handleRefetch } = useContext(UserContext);
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

    const updateContactViewed = async (userId) => {
        try {
            // This if else for UX;
            if (user?.packageInfo?.proposal?.contactViewLimit <= 0) {
                toast.warning("Your contact viewed limit finished!");
                return;
            } else {
                setContactShow(true);
            }

            const response = await Requests.Profile.UpdateContactViewed(userId, header)
            if (response?.status) {
                toast.success(response.message);
                handleRefetch()
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (user?.profileType === "Paid" && user?.packageInfo?.contactViewed?.indexOf(data?._id) > -1) {
            setContactShow(true);
        }
    }, [user, data?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleContactClick = () => {
        if (user?.profileType === "Paid") {
            updateContactViewed(data?._id)
        } else {
            setContactModel(true)
        }
    }

    const address = [data?.city, data?.stateDevision, data?.livingCountry || "Bangladesh"]
        .filter(info => info)
        .join(", ")

    return (
        <div className="profile_details">

            {/* About */}
            <InfoBox icon={aboutIcon} title="About">
                <p className="text_area">
                    {data?.about || data?.description || "No description added"}
                </p>
            </InfoBox>

            {/* Contact details */}
            <InfoBox icon={contactIcon} title="Contact Details">
                <div className={`contact_box ${contactShow ? "unlocked" : ""}`}>
                    <div className="contact_cells">
                        <div className="contact_cell">
                            <span className="cell_label">
                                <img src={phoneIcon} alt="" /> Contact Number
                            </span>
                            {
                                contactShow
                                    ? <a href={`tel:${data?.phone}`}>{orDash(data?.phone)}</a>
                                    : <span className="masked">+8801XXX-XXXXXX</span>
                            }
                        </div>

                        <div className="contact_cell">
                            <span className="cell_label">
                                <img src={emailIcon} alt="" /> Email ID
                            </span>
                            {
                                contactShow
                                    ? <a href={`mailto:${data?.email}`}>{orDash(data?.email)}</a>
                                    : <span className="masked">XXXXX@gmail.com</span>
                            }
                        </div>
                    </div>

                    {
                        !contactShow && (
                            user?.profileType === "Paid"
                                ? <button
                                    type="button"
                                    className="unlock_btn"
                                    onClick={handleContactClick}
                                >
                                    <Icon icon={eye} size={15} /> Show Contact
                                </button>
                                : <Link to="/my-ghotokbari/package" className="unlock_btn">
                                    <Icon icon={eye} size={15} /> Upgrade Now To View
                                </Link>
                        )
                    }
                </div>
            </InfoBox>

            {/* Lifestyle */}
            <InfoBox icon={lifeStyleIcon} title="Lifestyle">
                <p className="text_area">{orDash(data?.lifeStyle)}</p>
            </InfoBox>

            {/* Background */}
            <InfoBox icon={backgroundIcon} title="Background">
                <div className="detail_grid">
                    <DetailItem
                        label="Religion / Mother Tongue"
                        value={
                            (data?.religion || data?.language)
                                ? `${orDash(data?.religion)}, ${data?.language || "Bengali"}`
                                : null
                        }
                    />
                    <DetailItem label="Community / Social Order" value={data?.socialOrder} />
                    <DetailItem
                        label="Present And Permanent Address"
                        value={address ? `Lives in ${address}.` : null}
                        full
                    />
                </div>
            </InfoBox>

            {/* Family details */}
            <InfoBox icon={familyIcon} title="Family Details">
                <div className="detail_grid">
                    <DetailItem label="Family Location" value={data?.familyLocation} />
                    <DetailItem label="Family Native Location" value={data?.nativePlace} />
                    <DetailItem label="Family Type" value={data?.familyType} />
                    <DetailItem label="Family Affluence" value={data?.familyAffluence} />
                    <DetailItem label="Family Value" value={data?.familyValue} />
                    <DetailItem label="Father's Name" value={data?.fatherName} />
                    <DetailItem label="Father's Occupation" value={data?.fatherStatus} />
                    <DetailItem label="Mother's Name" value={data?.motherName} />
                    <DetailItem label="Mother's Occupation" value={data?.motherStatus} />
                    <DetailItem label="Your Order As Child" value={data?.yourOrder} />
                    <DetailItem label="No Of Brother" value={data?.numberOfBrothers} />
                    <DetailItem label="Married Brother" value={data?.numberOfBrothersMarried} />
                    <DetailItem label="No Of Sister" value={data?.numberOfSisters} />
                    <DetailItem label="Married Sister" value={data?.numberOfSistersMarried} />
                </div>
            </InfoBox>

            {/* Education & career */}
            <InfoBox icon={educationIcon} title="Education & Career">
                <div className="detail_grid">
                    <DetailItem label="Qualification" value={data?.qualification} />
                    <DetailItem label="College(S) Attended" value={data?.institute} />
                    <DetailItem label="Working With" value={data?.workingWith} />
                    <DetailItem label="Profession Area" value={data?.professionArea} />
                    <DetailItem
                        label="Monthly Income"
                        value={data?.annualIncome ? `${data.annualIncome} BDT` : null}
                    />
                </div>
            </InfoBox>

            {contactModel ?
                <ContactInfo
                    show={contactModel}
                    onHide={() => setContactModel(false)}
                />
                : null}

        </div>
    );
};

export default Index;
